// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3q8eV","content":"LoadingAlert_content__3sVV3"};